import { render, staticRenderFns } from "./contractList.vue?vue&type=template&id=70304a3e&scoped=true&"
import script from "./contractList.vue?vue&type=script&lang=js&"
export * from "./contractList.vue?vue&type=script&lang=js&"
import style0 from "./contractList.vue?vue&type=style&index=0&id=70304a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70304a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
